import { render, staticRenderFns } from "./CargoInquiry.vue?vue&type=template&id=e92e5720"
import script from "./CargoInquiry.vue?vue&type=script&lang=js"
export * from "./CargoInquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports